import { Button } from "@headlessui/react";
import { CSSProperties } from "react";

export const PrimaryButton = ({
  children,
  className,
  onClick,
  otherProps,
  disabled,
  style,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: Function;
  otherProps?: any;
  style?: CSSProperties;
  disabled?: boolean;
  "data-testid"?: string;
  "aria-label"?: string;
  "aria-labelledby"?: string;
}) => (
  <Button
    data-testid={dataTestId}
    aria-label={ariaLabel}
    aria-labelledby={ariaLabelledBy}
    className={`py-2 px-2 sm:px-3 md:px-8 rounded bg-blue-700 text-white data-[hover]:bg-blend-darken data-[active]:bg-blend-darken ${className}`}
    onClick={onClick}
    style={style}
    disabled={disabled}
    {...otherProps}
  >
    {children}
  </Button>
);
